import { render, staticRenderFns } from "./simplifyOwnerCar.vue?vue&type=template&id=5e3fe108&scoped=true"
import script from "./simplifyOwnerCar.vue?vue&type=script&lang=js"
export * from "./simplifyOwnerCar.vue?vue&type=script&lang=js"
import style0 from "./simplifyOwnerCar.vue?vue&type=style&index=0&id=5e3fe108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3fe108",
  null
  
)

export default component.exports